/**
 * AUT-398 (CP-09) — admin «Подборщики»: list, detail, disable / enable.
 *
 * Gate: `admin` role + `verify_inspectors`. PII (`name`, `phone`) arrives
 * REDACTED unless the caller holds `view_pii`; `city` is not PII here (it is
 * what the picker shows on their own public reports).
 */
/**
 * AUT-400 (CP-10a) — the state of a report's public link, as the admin
 * drawer shows it. `revoked` carries who closed it: the picker themself
 * (`picker`), staff through a disable (`admin`), or account deletion.
 */
export const ADMIN_PICKER_REPORT_LINK_STATES = ['active', 'revoked', 'none'];
/** How many reports the detail drawer lists. */
export const ADMIN_PICKER_RECENT_REPORTS_LIMIT = 10;
export const ADMIN_PICKER_STATE_FILTERS = ['all', 'active', 'disabled'];
/**
 * How the user became a picker — `inspectors.picker_source` (AUT-397): an
 * invite code, the no-code signup, or a company code. A legacy grant with no
 * source recorded counts as `invite`. Also the `?source=` filter of
 * `GET /admin/pickers` (AUT-400).
 */
export const ADMIN_PICKER_SOURCE_FILTERS = ['invite', 'self_signup', 'org'];
/** AUT-400 — `?q=` minimum length (name, or phone digits for `view_pii`). */
export const ADMIN_PICKER_SEARCH_MIN_LENGTH = 2;
/** AUT-400 — the disable / enable reason cap (the server validates the same). */
export const ADMIN_PICKER_REASON_MAX = 500;
//# sourceMappingURL=admin-picker.js.map